import React from 'react';
import { message, Space, Table, Pagination, Tag, Divider, Button } from 'antd';
import { Link } from 'react-router-dom';
import { httpClient } from "util/Api";
import { compareUIElementValue } from 'util/Compare';
import { config } from "util/config";
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { DragHandle, SortableItem, SortableBody, updateBeforeSortStart } from "components/UIBuilder/Global/SortableHelper";
import { FolderOpenOutlined, FolderOutlined, GroupOutlined, CaretRightOutlined, CaretDownOutlined } from '@ant-design/icons';
import { setTableColumns } from "components/UIBuilder/Global/TableHelper";
import { getSectionDataList } from "components/UIBuilder/Global/DataHelper";
import CustomBadge from 'components/CustomBadge';
import { arrayMoveImmutable } from 'array-move';
import CustomEmpty from "components/CustomEmpty";

export default class DefaultGroupTable extends React.Component {
  constructor(props) {
    super();
    this.state = {
      columns: [],
      data: [],
      sort: false,
      pagination: {
        current: 1,
        ...config.component.Pagination
      },
      loaded: false, // 加载是否完成
      selectedRowKeys: []
    }

    this.handlePaginationChange = this.handlePaginationChange.bind(this);

    //表格选择行的配置
    this.rowSelection = props.viewConfig.groupList[0].rowSelectionType !== null ? {
      type: props.viewConfig.groupList[0].rowSelectionType,
      onChange: (selectedRowKeys, selectedRows) => {
        console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      },
      ...this.state.rowSelection
    } : null;
  }

  // //只有数据源变化时才刷新table
  // shouldComponentUpdate(nextProps, nextState) {
  //   return nextState.data !== this.state.data;
  // }

  //获取table的表头和数据
  componentDidMount() {
    if (this.props.section.autoLoad) {
      this.getSectionDataByDefault();
    }
    this.setState({ columns: setTableColumns({ props: this.props, sort: this.state.sort, sectionComponent: this.props.parentComponent, pageComponent: this.props.pageComponent }) })
  }

  //点击分页后获取页面数据
  handlePaginationChange(current, pageSize) {
    getSectionDataList({ component: this, current: current, pageSize: pageSize });
  };

  //默认获取数据的方法
  getSectionDataByDefault() {
    getSectionDataList({ component: this, current: this.state.pagination.current, pageSize: this.state.pagination.pageSize });
  }

  //停止排序时设置数据
  onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) {
      const newData = arrayMoveImmutable(this.state.data.slice(), oldIndex, newIndex).filter(
        (el) => !!el,
      );
      this.setState({ data: newData })

      var keyArray = newData.map((item, index) => {
        return item.key;
      });
      operationalFunction({ functionName: 'sortBySection', sectionName: this.props.section.name, parameter: keyArray, sectionComponent: this.props.parentComponent, pageComponent: this.props.pageComponent });
    }
  };

  DraggableContainer = (props) => (
    <SortableBody
      useDragHandle
      disableAutoscroll
      helperClass="row-dragging"
      updateBeforeSortStart={updateBeforeSortStart}
      onSortEnd={this.onSortEnd}
      {...props}
    />
  );

  DraggableBodyRow = ({ className, style, ...restProps }) => {
    const index = this.state.data.findIndex((x) => x.key === restProps['data-row-key']);
    return <SortableItem index={index} {...restProps} />;
  };


  render() {
    return (
      <>
        {
          this.state.loaded ?
            this.state.data.length > 0 ? //判断有没有数据
              this.state.data.map((group, i) =>
                <div key={group.key} className='group-div'>
                  <Button
                    icon={<CustomBadge icon={group.Collapsed === true ?
                      <CaretRightOutlined style={{ marginRight: '4px' }} /> :
                      <CaretDownOutlined style={{ marginRight: '4px' }} />}
                      text={<>{group.Name}<span style={{ marginLeft: '6px' }}>({group.DataList.length})</span></>}
                      backgroundColor={config.component.ColorPicker.defaultColor}
                      verticalAlign="top"
                    />}
                    type="link"
                    style={{ width: 'auto', marginTop: i === 0 ? '3px' : null }}
                    onClick={() => {
                      let data = this.state.data.map((dataGroup, j) => {
                        if (dataGroup.Name === group.Name) {
                          if (dataGroup.Collapsed !== true) {
                            dataGroup.Collapsed = true;
                          } else {
                            dataGroup.Collapsed = false;
                          }
                        }
                        return dataGroup;
                      });
                      this.setState({ data });
                    }}
                  />
                  <Divider />
                  {
                    group.DataList.length > 0 ?
                      <Table
                        bordered
                        size="small"
                        style={{ display: group.Collapsed !== true ? 'block' : 'none' }}
                        rowSelection={this.rowSelection}
                        columns={this.state.columns}
                        dataSource={group.DataList}
                        scroll={config.component.Table.scroll}
                        pagination={this.props.viewConfig.groupList[0].pageable ?
                          {
                            ...this.state.pagination,
                            onChange: this.handlePaginationChange
                          }
                          : false}
                        components={this.state.sort ? //判断是否带排序功能
                          {
                            body: {
                              wrapper: this.DraggableContainer,
                              row: this.DraggableBodyRow,
                            },
                          } : null}
                      /> : <span>No records</span>
                  }
                </div>)
              :
              <CustomEmpty /> : <img className='loading-icon' src="assets/images/icon/loading.svg" />
        }
      </>
    )
  }
}
